export default __webpack_public_path__ + "static/media/Logo-2do-md-600px.2c1a34e2.svg";